import React from 'react';
import styled, { keyframes } from 'styled-components';

const Testimonials = () => {
  const testimonialsData = [
    {
      id: 1,
      text: "“Our two UK-based manufacturing sites operate to the highest standards of food production and safety, guaranteeing the taste and quality of every product we bring to market. And for your added reassurance our production sites, and all our suppliers, are Brand Reputation Compliance Global Standards (BRCGS) accredited.”",
      name: "Albert Juan",
      role: "CEO & Founder, Archin Studio",
      img: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=150&q=80",
      bg: "#ffffff",
      color: "#1a1a1a",
      transform: "rotate(-8deg)",
      marginTop: "0px",
      zIndex: 1
    },
    {
      id: 2,
      text: "“Our two UK-based manufacturing sites operate to the highest standards of food production and safety, guaranteeing the taste and quality of every product we bring to market. And for your added reassurance our production sites, and all our suppliers, are Brand Reputation Compliance Global Standards (BRCGS) accredited.”",
      name: "Koen Chegg",
      role: "CEO & Founder, Archin Studio",
      img: "https://images.unsplash.com/photo-1599566150163-29194dcaad36?auto=format&fit=crop&w=150&q=80",
      bg: "#0d2074",
      color: "#ffffff",
      transform: "rotate(-4deg)",
      marginTop: "20px",
      zIndex: 2
    },
    {
      id: 3,
      text: "“Our two UK-based manufacturing sites operate to the highest standards of food production and safety, guaranteeing the taste and quality of every product we bring to market. And for your added reassurance our production sites, and all our suppliers, are Brand Reputation Compliance Global Standards (BRCGS) accredited.”",
      name: "Warren Daniel",
      role: "CEO & Founder, Archin Studio",
      img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80",
      bg: "#222222",
      color: "#ffffff",
      transform: "rotate(0deg)",
      marginTop: "-20px",
      zIndex: 3
    },
    {
      id: 4,
      text: "“Our two UK-based manufacturing sites operate to the highest standards of food production and safety, guaranteeing the taste and quality of every product we bring to market. And for your added reassurance our production sites, and all our suppliers, are Brand Reputation Compliance Global Standards (BRCGS) accredited.”",
      name: "Elvin Bond",
      role: "CEO & Founder, Archin Studio",
      img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=150&q=80",
      bg: "#ffffff",
      color: "#1a1a1a",
      transform: "rotate(4deg)",
      marginTop: "10px",
      zIndex: 4
    },
    {
      id: 5,
      text: "“Our two UK-based manufacturing sites operate to the highest standards of food production and safety, guaranteeing the taste and quality of every product we bring to market. And for your added reassurance our production sites, and all our suppliers, are Brand Reputation Compliance Global Standards (BRCGS) accredited.”",
      name: "Abbas",
      role: "CEO & Founder, Archin Studio",
      img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&q=80",
      bg: "#e5e5e5",
      color: "#1a1a1a",
      transform: "rotate(8deg)",
      marginTop: "-10px",
      zIndex: 5
    },
    {
      id: 6,
      text: "“Our two UK-based manufacturing sites operate to the highest standards of food production and safety, guaranteeing the taste and quality of every product we bring to market. And for your added reassurance our production sites, and all our suppliers, are Brand Reputation Compliance Global Standards (BRCGS) accredited.”",
      name: "Jessamine Mumtaz",
      role: "CEO & Founder, Archin Studio",
      img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=150&q=80",
      bg: "#0d2074",
      color: "#ffffff",
      transform: "rotate(12deg)",
      marginTop: "20px",
      zIndex: 6
    }
  ];

  return (
    <TestimonialArea className="tp-testimonial-area p-relative fix">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="tp-testimonial-title-wrap z-index-3">
              <div className="tp-testimonial-title-box mb-40 text-center">
                <TitleHeading>Quality, transparency and responsibility are at the heart of our business. Don't just take our word for it—see what our customers have to say.</TitleHeading>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MarqueeContainer className="marquee-container z-index-3">
        <MarqueeTrack className="marquee-track">
          {[...testimonialsData, ...testimonialsData].map((item, index) => (
            <TCardWrap
              key={index}
              className="t-card-wrap"
              $bg={item.bg}
              $transform={item.transform}
              $zIndex={item.zIndex}
              $marginTop={item.marginTop}
            >
              <TCardText className="t-card-text" $color={item.color}>{item.text}</TCardText>
              <TAuthorBox className="t-author-box">
                <TAuthorImg className="t-author-img" src={item.img} alt={item.name} />
                <TAuthorInfo className="t-author-info">
                  <h5 style={{ color: item.color }}>{item.name}</h5>
                  <span style={{ color: item.color }}>{item.role}</span>
                </TAuthorInfo>
              </TAuthorBox>
            </TCardWrap>
          ))}
        </MarqueeTrack>
      </MarqueeContainer>
    </TestimonialArea>
  );
};

const scrollMarquee = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const TestimonialArea = styled.div`
  overflow: hidden;
  padding: 120px 0;
  background-color: #050505;
  background-image: url(assets/img/home-01/testimonial/noise.png);

  @media (max-width: 767px) {
    padding: 60px 0;
  }
`;

const TitleHeading = styled.h4`
  color: white;
  font-size: 28px;
  line-height: 1.4;

  @media (max-width: 767px) {
    font-size: 20px;
  }
  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const MarqueeContainer = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 60px 0;
  position: relative;

  @media (max-width: 767px) {
    padding: 30px 0;
  }
`;

const MarqueeTrack = styled.div`
  display: flex;
  width: max-content;
  animation: ${scrollMarquee} 45s linear infinite;
  align-items: center;

  &:hover {
    animation-play-state: paused;
  }
`;

const TCardWrap = styled.div`
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  margin-left: -50px;
  width: 340px;
  padding: 40px 30px;
  box-shadow: -20px 0 40px rgba(0, 0, 0, 0.7);
  border: 4px solid black;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 500px;
  background-color: ${props => props.$bg};
  transform: ${props => props.$transform};
  z-index: ${props => props.$zIndex};
  margin-top: ${props => props.$marginTop};

  &:hover {
    transform: translateY(-30px) scale(1.08) rotate(0deg) !important;
    z-index: 50 !important;
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.8);
  }

  @media (max-width: 991px) {
    width: 320px;
    margin-left: -20px;
    padding: 30px 20px;
    min-height: 320px;
  }

  @media (max-width: 480px) {
    width: 280px;
    margin-left: -16px;
    padding: 24px 18px;
    min-height: 280px;
  }
`;

const TCardText = styled.p`
  font-size: 17px;
  line-height: 1.6;
  margin-bottom: 30px;
  font-weight: 500;
  color: ${props => props.$color};

  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 20px;
  }
`;

const TAuthorBox = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const TAuthorImg = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
`;

const TAuthorInfo = styled.div`
  h5 {
    margin: 0 0 5px 0;
    font-size: 16px;
    font-weight: 700;
  }

  span {
    font-size: 12px;
    opacity: 0.8;
  }
`;

export default Testimonials;
